/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Group_Variants_RequiredInputs */

const vi_error_shop_group_variants_required = /** @type {(inputs: Error_Shop_Group_Variants_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm ít nhất 1 loại (SKU) — nhóm chưa có loại nào sẽ không hiện trên website và Mini App.`)
};

/**

* @param {Error_Shop_Group_Variants_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_group_variants_required = /** @type {((inputs?: Error_Shop_Group_Variants_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Group_Variants_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_group_variants_required(inputs)
});